module.exports = __webpack_public_path__ + "img/201606-2-768x1024.6785dd94.jpg";